"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const _1 = require(".");
const base_1 = __importDefault(require("./base"));
const defaults_1 = require("./defaults");
class Video extends base_1.default {
    constructor(data = {
        id: undefined,
        video_url: undefined,
        caption_url: undefined,
        name: undefined,
        created_at: undefined,
        thumbnail: undefined,
    }) {
        super(data);
        this.id = (0, defaults_1.defaultString)(data.id);
        this.video_url = (0, defaults_1.defaultString)(data.video_url);
        this.caption_url = (0, defaults_1.defaultString)(data.caption_url);
        this.name = (0, defaults_1.defaultString)(data.name);
        this.createdAt = (0, defaults_1.defaultString)(data.created_at);
        this.thumbnail = new _1.Image((0, defaults_1.defaultObject)(data.thumbnail));
    }
    get videoUrl() {
        return this.video_url;
    }
    get captionUrl() {
        return this.caption_url;
    }
}
exports.default = Video;
